import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// @material-ui/icons

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";

import "react-quill/dist/quill.snow.css";

import styles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";

import { useParams, useHistory } from "react-router-dom";
import Button from "../../components/CustomButtons/Button";
import { Dialog, DialogContent, DialogTitle, Slide } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import { bannerService } from "services/bannerService";

const useStyles = makeStyles(styles);

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

export default function BridgeView() {
  const [modal, setModal] = React.useState(false);
  const [banner, setBanner] = React.useState({});
  const { id } = useParams();
  const history = useHistory();

  async function fetchBanner(id) {
    const { data } = await bannerService.view(id);
    console.log("🍕 ~ data", data);
    setBanner(data);
    setModal(true);
  }

  React.useEffect(() => {
    fetchBanner(id);
  }, []);

  const classes = useStyles();

  function close() {
    setModal(false);
    history.push("/admin/banner");
  }

  return (
    <Dialog
      classes={{
        root: classes.center,
        paper: classes.modal,
      }}
      open={modal}
      transition={Transition}
      keepMounted
      onClose={close}
      aria-labelledby="modal-slide-title"
      aria-describedby="modal-slide-description"
      size="lg"
    >
      <DialogTitle id="classic-modal-slide-title" disableTypography className={classes.modalHeader}>
        <Button
          justIcon
          className={classes.modalCloseButton}
          key="close"
          aria-label="Close"
          color="transparent"
          onClick={close}
        >
          <Close className={classes.modalClose} />
        </Button>
        <h4 className={classes.modalTitle}>{banner.title}</h4>
      </DialogTitle>
      <DialogContent id="modal-slide-description" className={classes.modalBody}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={4}>
            <h5>
              <strong>Image: </strong>
            </h5>
            <img src={banner?.image} alt="..." width="100%" />
          </GridItem>
          <GridItem xs={12} sm={12} md={8}>
            <GridContainer>
              <GridItem xs={12} sm={12} md={4}>
                <h5>
                  <strong>Name:</strong>
                </h5>
              </GridItem>
              <GridItem xs={12} sm={12} md={8}>
                <h5>{banner.name}</h5>
              </GridItem>
            </GridContainer>

            <GridContainer>
              <GridItem xs={12} sm={12} md={4}>
                <h5>
                  <strong>Order: </strong>
                </h5>
              </GridItem>
              <GridItem xs={12} sm={12} md={8}>
                <h5>{banner.order}</h5>
              </GridItem>
            </GridContainer>

            <GridContainer>
              <GridItem xs={12} sm={12} md={4}>
                <h5>
                  <strong>Mint link: </strong>
                </h5>
              </GridItem>
              <GridItem xs={12} sm={12} md={8}>
                <h5>{banner.mintLink}</h5>
              </GridItem>
            </GridContainer>

            <GridContainer>
              <GridItem xs={12} sm={12} md={4}>
                <h5>
                  <strong>Description: </strong>
                </h5>
              </GridItem>
              <GridItem xs={12} sm={12} md={8}>
                <h5>{banner.description}</h5>
              </GridItem>
            </GridContainer>
          </GridItem>
        </GridContainer>
      </DialogContent>
    </Dialog>
  );
}
